<template>
  <v-container class="gray pa-3 ma-0 fluid subtitle-1 text-justify">
    <h1 class="mt-4">Instalação do Visual Studio Code</h1>
    <br />
    <v-layout>
      <v-flex>
        <v-row>
          <v-col class="col-10 offset-1">
            <p>
              Eu sugiro o uso do Visual Studio Code para usarmos como IDE de desenvolvimento. É leve, gratuita, boa capacidade de edição e
              trabalha bem tanto com a parte
              <i>frontend</i> do nosso código quanto com a parte
              <i>backend</i>.
            </p>

            <p>
              Instalar o VS Code é muito simples. Basta navegarmos até
              <a
                target="_blank"
                href="https://code.visualstudio.com/"
              >seu site</a> e fazer o download de seu instalador.
            </p>
          </v-col>

          <v-col class="col-6 offset-3">
            <v-img src="@/assets/vscode.jpg"></v-img>
          </v-col>

          <v-col class="mt-3 col-10 offset-1">
            <p>Basta clicar no botão azul para fazer o download do instalador.</p>
            <p>Outras IDEs podem ser usadas. Eclipse, Netbeans, Atom, etc.</p>
            <p>É puramente uma questão de escolha pessoal. Eu sugiro o VS Code porque dá para fazer tudo usando só o VS Code...</p>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="col-1 offset-9">
            <v-btn class="primary" to="/installwails">Instalação do Wails</v-btn>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
    <v-btn fab dark large color="success" fixed right bottom @click="GoTop()">
      <v-icon dark>mdi-arrow-up-bold</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: "Installvscode",
  mounted() {
    this.$vuetify.goTo(0);
  },
  methods: {
    GoTop() {
      this.$vuetify.goTo(0);
    }
  }
};
</script>
